import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import type { SxProps, Theme } from '@mui/material/styles';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useTouchEditVisible } from '@/core/store/touchEdit/touchEditSelectors';
import { mergeSx } from '@/utils/mergeSx';

import { inlineEditTriggerButtonStyles as sx } from './InlineEditTriggerButton.styles';

type Props = {
	onClick: (event: MouseEvent<HTMLButtonElement>) => void;
	ariaLabel: string;
	markerAttr?: string;
	customSx?: {
		desktopButton?: SxProps<Theme>;
		iconButton?: SxProps<Theme>;
	};
};

export const InlineEditTriggerButton = ({
	onClick,
	ariaLabel,
	markerAttr,
	customSx
}: Props) => {
	const { t } = useTranslation();
	const touchEditVisible = useTouchEditVisible();

	return (
		<>
			<Button
				type='button'
				onClick={onClick}
				aria-label={ariaLabel}
				{...(markerAttr ? { [markerAttr]: true } : {})}
				startIcon={<EditOutlinedIcon />}
				size='small'
				sx={mergeSx(
					sx.desktopButton,
					sx.desktopButtonVisibility(touchEditVisible),
					customSx?.desktopButton
				)}
			>
				{t('Edit')}
			</Button>
			<IconButton
				onClick={onClick}
				aria-label={ariaLabel}
				size='small'
				sx={mergeSx(sx.iconButton(touchEditVisible), customSx?.iconButton)}
			>
				<EditOutlinedIcon fontSize='inherit' />
			</IconButton>
		</>
	);
};
